import { InteractionRequiredAuthError } from "@azure/msal-browser";
import { isLoadTestAuthEnabled } from "./loadTestAuth";

let sessionExpiryHandled = false;

export class AuthSessionExpiredError extends Error {
  constructor(message = "Die Sitzung ist abgelaufen.") {
    super(message);
    this.name = "AuthSessionExpiredError";
  }
}

export const resetSessionExpiryHandling = () => {
  sessionExpiryHandled = false;
};

export const handleExpiredSession = async (msalInstance) => {
  if (sessionExpiryHandled) return;
  sessionExpiryHandled = true;

  console.warn("Authentifizierung abgelaufen. Lokale Sitzung wird beendet.");

  try {
    if (msalInstance.setActiveAccount) {
      msalInstance.setActiveAccount(null);
    }
    if (msalInstance.clearCache) {
      await msalInstance.clearCache();
    }
  } catch (error) {
    console.error("Lokales Abmelden fehlgeschlagen:", error);
  }

  window.dispatchEvent(new Event("auth:sessionExpired"));

  const loginUrl = `${window.location.origin}/login`;
  if (window.location.href !== loginUrl) {
    window.location.replace(loginUrl);
  }
};

// Async Funktion, um den Token zu erwerben
const getToken = async (msalInstance, scopes) => {
  if (isLoadTestAuthEnabled()) {
    return "load-test";
  }

  const accounts = msalInstance.getAllAccounts();
  console.log("Available accounts:", accounts.length);
  
  if (accounts.length > 0) {
    try {
      // Versuche, einen Token still zu erwerben
      const response = await msalInstance.acquireTokenSilent({
        scopes: scopes,
        account: accounts[0],
      });
      // Nie das Ergebnisobjekt ausgeben: Es enthaelt Access- und ID-Token.
      console.log("Stille Token-Akquise erfolgreich.");
      return response.accessToken;
    } catch (error) {
      console.error("Silent token acquisition failed:", error);
      
      if (error instanceof InteractionRequiredAuthError) {
        await handleExpiredSession(msalInstance);
        throw new AuthSessionExpiredError();
      }
      console.error("Token-Akquise fehlgeschlagen:", error);
      return null;
    }
  } else {
    console.log("Keine Konten gefunden.");
    return null;
  }
};

export default getToken;
